import { defineMessages } from 'react-intl';

export default defineMessages({
    nextStepLabel: {
        id: 'ml.quoteandbind.pup.AdditionalInfoPreBind.additionalInformationNext',
        defaultMessage: 'We\'ll continue {purchaseDetails} next'
    },
    purchaseDetails: {
        id: 'ml.quoteandbind.pup.AdditionalInfoPreBind.entering your purchase details',
        defaultMessage: 'entering your purchase details'
    },
    additionalDetailsHeader: {
        id: 'ml.quoteandbind.pup.additionalInformation.Additional Details',
        defaultMessage: 'Additional Details'
    },
    additionalDetailsSubHeader: {
        id: 'ml.quoteandbind.pup.additionalInformation.We\'re almost done! Just a few more questions',
        defaultMessage: 'We\'re almost done! Just a few more questions'
    },
    uniqueEmailAddAlert: {
        id: 'ml.quoteandbind.pup.additionalInformation.Each customer must have a unique email address.',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    liabilityLossQuestion: {
        id: 'ml.quoteandbind.pup.additionalInformation.Have there been any umbrella or personal liability losses in the last 5 years?',
        defaultMessage: 'Have there been any umbrella or personal liability losses in the last 5 years?'
    }
});
